export const baseURL = process.env?.REACT_APP_API_URL ||  window._env_?.REACT_APP_API_URL || "https://api.park.play.nizek.shop/"